<template>
	<div class="emptybox" v-if="!emptylist || emptylist.length<=0">
		<img src="@/images/empty.png"/>
		<div>{{emptytext}}</div>
	</div>
</template>

<script>
	export default {
		name: 'emptymain',
		props: {
			emptytext: {
				type: String,
				default: '暂无数据'
			},
			emptylist: {
				type: Array,
				default: []
			},
		},
	}
</script>